import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProductCollectionService {
  changesSubject = new BehaviorSubject<boolean>(false);
  watchChanges = this.changesSubject.asObservable();

  categoryIds: string = '';

  constructor(
    private http: HttpClient
  ) { }

  changesMade() {
    this.changesSubject.next(true);
  }

  generateReport(params: { [key: string]: string }): Promise<string> {
    return new Promise((resolve, reject) => {
      this.http.post('/v4/products/reports', null, {
        params
      }).subscribe({
        next: (resp: any) => {
          if (resp.statusCode === 200 && resp.result && resp.result.reportId) {
            resolve(resp.result.reportId);
          } else {
            reject('resp.result.reportId does not exist');
          }
        },
        error: (err) => {
          console.error('ProductCollectionService:generateReport()', err);
          reject(err);
        }
      });
    });
  }

  generateCount(fields: { [key: string]: string }): Promise<string> {
    return new Promise((resolve, reject) => {
      this.http.post('/v4/products/reports/count', null, {
        params: fields
      }).subscribe({
        next: (resp: any) => {
          if (resp.statusCode === 200 && resp.result && resp.result.reportId) {
            resolve(resp.result.reportId);
          } else {
            reject('resp.result.reportId not found');
          }
        },
        error: (err) => {
          console.error('ProductCollectionService:generateCount()', err);
          reject(err);
        }
      });
    });
  }

  linkCountToReport(reportId: string): Promise<string> {
    return new Promise((resolve, reject) => {
      this.http.post('/v4/products/reports/countToReport', null, {
        params: {
          reportId
        }
      }).subscribe({
        next: (resp: any) => {
          if (resp.statusCode === 200 && resp.result && resp.result.reportId) {
            resolve(resp.result.reportId);
          } else {
            reject('resp.result.reportId not found in linkCountToReport() method');
          }
        },
        error: (err) => {
          console.error('ProductCollectionService:generateCount()', err);
          reject(err);
        }
      });
    });
  }

  getBrands(search: string, limit: number = 10) {
    return this.http.get('v4/products/reports/brands', { params: { name: search, limit } })
      .pipe(
        map((resp: any): string[] => {
          if (resp.statusCode === 200 && resp.result && resp.result.brands) {
            return resp.result.brands;
          }
          return [];
        })
      );
  }

}
